import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ClientCreateForm from '../views/clients/ClientCreateForm';
import ClientUpdateForm from '../views/clients/ClientUpdateForm';

export default class Clients extends AbstractController {
    protected controllerName = 'Clients';

    protected getDefaultCreateFormComponent() {
        return ClientCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return ClientUpdateForm;
    }
}
